// test commit
export const BEGIN_PROCESS_CONSTANT = {
  TITLE: "Generate Assets",
  DESCRIPTION:
    "Providing a detailed description helps generate the highest-quality outputs. Keep in mind that narrow, contextually specific inputs tend to outperform broad descriptions. Review our brief guidelines below for more help.",
  BRIEF_GUIDELINES: [
    "Information should be unique to the campaign",
    "Do not enter sensitive, confidential or proprietary information (e.g., patents, product recipes)",
    "Do not enter unethical or inaccurate information",
    "Always follow inclusive language guidelines",
  ],
  IMAGE_DESCRIPTION: "Image Description",
  IMAGE_DESCRIPTION_INFO: "Enter details that best describes the creative output you want to achieve.",
  TEXT_DESCRIPTION: "Text Description",
  GENERATE_ASSETS_BUTTON_TEXT: "Generate Assets",
  IMAGE_DESCRIPTION_REQUIRED_ERROR: "Please make sure you enter an image description.",
  TEXT_DESCRIPTION_REQUIRED_ERROR: "Please make sure you enter a description.",
  RAI_CHECK_FAILED: "Rai Check Failed",
  IMAGE_DESCRIPTION_PRODUCT_PLACEMENT: "Image Background Description",
};

export const CONCEPT_CREATING_FIELD_NAME = {
  IMAGE_DESCRIPTION: "imageDescription",
  TEXT_DESCRIPTION: "textDescription",
};
